// extracted by mini-css-extract-plugin
export default {"products":"Qz-z","card":"Rz-z","oosMessaging":"Sz-z"};